module.exports = __webpack_public_path__ + "img/landing-03.41cfb9f4.png";